import React, { useState, useRef } from "react";
import * as Common from ".";

const FileUploader = ({
  label,
  helperText,
  onUploadClick,
  accept,
  isUploading = false,
  disabled = false,
  singleButton = false,
  btnText = "Upload file",
  singleBtnClassName = "",
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  // Determine the style for the real file input based on the singleButton prop
  const realButtonInputStyle = singleButton ? "hidden" : "block";
  const _singleBtnClassName =
    singleBtnClassName ||
    "rounded-md text-xs text-center text-gray-900 border border-gray-300 cursor-pointer px-4 py-2";

  // Handle file change event
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file);

    if (singleButton) {
      onUploadClick(file);
    }

    event.target.value = null;
  };

  // Handle file upload button click
  const handleUpload = () => {
    if (selectedFile) {
      onUploadClick(selectedFile);
    }
  };

  // SmallUploadButton component for the custom upload button
  const SingleButton = () => (
    <button
      type="button"
      onClick={() => fileInputRef.current.click()}
      disabled={isUploading || disabled}
      className={`
      ${_singleBtnClassName} flex justify-center items-center
      ${
        disabled && !isUploading
          ? "disabled:bg-gray-400 disabled:text-white"
          : ""
      }
      disabled:cursor-not-allowed
      hover:bg-gray-200 hover:text-white
    `}
    title=""
    >
      {isUploading ? <Common.Spinner size="4" /> : btnText}
    </button>
  );

  return (
    <div>
      {label && (
        <label
          className="block mb-2 text-sm font-medium text-gray-900"
          htmlFor="file_input"
        >
          {label}
        </label>
      )}

      <div className="flex items-center gap-4">
        {/* File Input */}
        <input
          ref={fileInputRef}
          onChange={handleFileChange}
          disabled={isUploading || disabled}
          accept={accept}
          className={`${realButtonInputStyle} w-full text-x cursor-pointer bg-gray-50`}
          type="file"
        />

        {/* Upload Button */}
        {!singleButton && (
          <button
            onClick={handleUpload}
            disabled={!selectedFile || isUploading || disabled}
            type="button"
            className={`
            px-4 py-2 text-xs font-medium rounded-lg 
            bg-primary text-white hover:bg-secondary
            focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-1
            disabled:bg-gray-300 disabled:cursor-not-allowed
            transition-colors duration-200
          `}
          >
            {isUploading ? <Common.Spinner /> : btnText}
          </button>
        )}

        {/* Single Button Mode */}
        {singleButton && <SingleButton />}
      </div>

      {helperText && <p className="mt-1 text-xs text-gray-500">{helperText}</p>}
    </div>
  );
};

export default FileUploader;
